export class NsnShipments {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    shipmentsCount: number;
}
